import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import chroma from 'chroma-js'
import {withStyles} from "@material-ui/styles"
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import styles from './styles/ColorBoxStyles'

class ColorBox extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { copied: false };
    this.changeCopyState = this.changeCopyState.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
    this.handleSelectColor = this.handleSelectColor.bind(this);
  }
  changeCopyState() {
    this.setState({ copied: true }, () => {
      clearTimeout(this._copyTimer);
      this._copyTimer = setTimeout(() => this.setState({ copied: false }), 1400);
    });
  }
  componentWillUnmount() {
    clearTimeout(this._copyTimer);
  }
  handleCopy() {
    const { background } = this.props;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(background);
        this.changeCopyState();
      } else {
        window.prompt("Copy color code:", background);
      }
    } catch (e) {
      window.prompt("Copy color code:", background);
    }
  }
  handleSelectColor(e) {
    e.stopPropagation();
    const { name, background, onSelectColor, isSelected } = this.props;
    if (onSelectColor) {
      onSelectColor({ name, color: background }, isSelected);
    }
  }
  render() {
    const { name, background, paletteId, id, showingFullColorPalette, classes, onSelectColor, isSelected } = this.props;
    const { copied } = this.state;

    const luminance = chroma(background).luminance();
    const textColor = luminance > 0.5 ? '#000' : '#fff';

    return (
        <div
          style={{ background: background }}
          className={classes.ColorBox}
          onClick={this.handleCopy}
        >
          {/* Subtle, Coolors-style copy confirmation toast */}
          <div className={`${classes.toast} ${copied ? classes.toastShow : ''}`}>
            <CheckCircleIcon style={{ fontSize: 18 }} />
            <span>{background.toUpperCase()} copied to clipboard</span>
          </div>

          <div className={classes.boxContent}>
            <span className={classes.colorName}>{name}</span>
          </div>

          {onSelectColor && (
            <Tooltip
              title={isSelected ? "Remove from export selection" : "Add to export selection"}
              placement="right"
              arrow
            >
              <IconButton
                className={classes.selectButton}
                onClick={this.handleSelectColor}
                size="small"
                style={{ color: textColor }}
              >
                {isSelected ? <CheckCircleIcon /> : <AddCircleIcon />}
              </IconButton>
            </Tooltip>
          )}
          {showingFullColorPalette && (
            <Tooltip title="View all shades of this color" placement="bottom" arrow>
              <Link
                to={`/palette/${paletteId}/${id}`}
                onClick={(e) => e.stopPropagation()}
              >
                <span className={classes.seeMore}>MORE</span>
              </Link>
            </Tooltip>
          )}
        </div>
    );
  }
}

export default withStyles(styles)(ColorBox)
